import React from 'react';
import PropTypes from 'prop-types';
import './Popup.css';
import Draggable from 'react-draggable';

const Popup = React.forwardRef(({ isOpen, children, styles, isDrag }, ref) => {
    if (!isOpen) return <></>
    return (
        <>
            {
                isDrag ?
                    <Draggable >
                        <div className='layout' style={styles}>
                            {children}
                        </div>
                    </Draggable> :
                    <div ref={ref} className='layout' style={styles}>
                        {children}
                    </div>
            }
        </>
    )
});

Popup.propTypes = {
    isOpen: PropTypes.bool.isRequired,
    children: PropTypes.node.isRequired,
    setIsOpen: PropTypes.func,
    styles: PropTypes.object,
}

Popup.defaultProps = {
    isOpen: false,
    setIsOpen: (state) => { },
    styles: {},
}

export default Popup;